import useSWR from 'swr';

import { fetchEndpointData } from '@utils/fetchEndpointData';

import type {
  SustainabilityReportingQuery,
  SustainabilityReportingResponse,
} from './endpoints/SustainabilityReportingEndpoint.types';

export const SUSTAINABILITY_REPORTING_SWR_KEY = 'sustainability-reporting';

export async function getSustainabilityReporting(
  filter: SustainabilityReportingQuery,
): Promise<SustainabilityReportingResponse> {
  const params = new URLSearchParams();
  params.set('startDate', filter.startDate);
  params.set('endDate', filter.endDate);
  if (filter.customerId != null) {
    params.set('customerId', filter.customerId.toString());
  }

  return fetchEndpointData<SustainabilityReportingResponse>(`/api/v1/sustainability-reporting?${params.toString()}`);
}

/**
 * SWR hook mirroring the old `useSustainabilityReportingQuery`. Pass `null`
 * filter to disable fetching (equivalent to urql `pause: !timeFrame`).
 */
export function useSustainabilityReporting(filter: SustainabilityReportingQuery | null) {
  return useSWR(
    filter ? [SUSTAINABILITY_REPORTING_SWR_KEY, filter.startDate, filter.endDate, filter.customerId] : null,
    () => getSustainabilityReporting(filter!),
  );
}
